export interface IEditFormatTree {
  editFormatTree(): Promise<void>;
}

export function instanceOfIEditFormatTree(instance: any): instance is IEditFormatTree {
  return (instance.editFormatTree !== undefined);
}
